import * as ACTION_TYPES from '../types';

let initialState = {
  invoiceList: [],
  invoice: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_CRM_INVOICES:
        return {...state, invoiceList: action.data };

      case ACTION_TYPES.DELETE_CRM_INVOICE:
        let newList = state.invoiceList.filter(invoice => invoice._id !== action.id);
        return {...state, invoiceList: newList };
      
      case ACTION_TYPES.GET_CRM_INVOICE_BY_ID:
        return {...state, invoice: action.data};
      
      case ACTION_TYPES.GET_INVOICE_BY_LEADID:
        return { ...state, invoiceList: action.data };  

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_CRM_INVOICE:
        return {...state, invoiceList: []};

      default:
        return state;
    }
  };